import { Pipe, PipeTransform, Inject } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'displayTerritory',
})
export class DisplayTerritoryPipe implements PipeTransform {
  constructor(
    @Inject('$translate') private $translate,
  ) {}

  transform(
    territory: string,
  ): string {
    if (territory && territory !== 'unknown') {
      return this.$translate.instant(`common.territories.${territory}`)
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/display-territory.pipe.ts